<!--
 * @Descripttion: 
 * @version: 
 * @Author: 
 * @Date: 2025-03-06 11:10:30
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-03-06 16:18:16
-->
<template>
  <div>
    <div id="lesson-html" v-loading="loadingLesson"></div>
    <div v-if="lessonData.lesson_data_download_url === null" class="no-lesson-placeholder">
        <p>No Page</p>
    </div>
  </div>
</template>

<script>
import { customerCoursesLessonDetail } from "@/api/course";
import GrapesJsRenderer from "@/utils/json-to-html/index";
export default {
  data() {
    return {
        loadingLesson: false,
        lessonData: {}
    };
  },
  methods: {
    // 根据url请求页面json
    async getPageReqUrl(json_url) {
      try {
        let response = await fetch(json_url);
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        let data = await response.json();
        return data;
      } catch (error) {
        console.error("Error fetching JSON:", error);
        console.log('Error fetching JSON');
        
      }
    },
    // 清空内容
    tickHtml() {
        this.$nextTick(() => {
            let lessonHtml = document.querySelector('#lesson-html')
            lessonHtml.innerHTML = ''
        })
    },
    // 获取课程文章详情
    async getLessonDetail(courseId, lessonId) {
        this.loadingLesson = true
      const resp = await customerCoursesLessonDetail(courseId, lessonId);
      console.log("resp", resp);
      if (resp.success) {
          this.tickHtml()
          this.lessonData = resp.body
        const lesson_data_download_url =
          resp.body.lesson_data_download_url === null
            ? ""
            : resp.body.lesson_data_download_url;
        
        const renderer = new GrapesJsRenderer({
            container: "#lesson-html",
            useIframe: true,
            injectStyles: true,
        });

        if (lesson_data_download_url != "") {
          this.getPageReqUrl(lesson_data_download_url)
            .then((data) => {
              
              renderer.render(data);
              this.loadingLesson = false
            })
            .catch((error) => {
                this.loadingLesson = false
              console.log("error", error);
            });
        }else{
            // renderer.render({});
            this.tickHtml()
            this.loadingLesson = false
        }
      }else{
          this.loadingLesson = false
      }
    },
  },
};
</script>

<style scoped>
.no-lesson-placeholder {
  width: 100%;
  height: 65vh;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f7fa;
  border-radius: 4px;
  color: #909399;
}
</style>